import { useQuery } from "@tanstack/react-query";
import { ListCodesQueryFilters, UseListCodesQueryOptions } from "./types";
import { getCodesService } from "./service";

export const listCodesQueryKey = ["limited_code_admin"];

export function useListCodesQuery(
  filters?: ListCodesQueryFilters,
  options?: UseListCodesQueryOptions
) {
  const queryKey = listCodesQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getCodesService(filters),
    ...options,
  });
}
